
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $dA2FI = parcelRequire("dA2FI");
// ── Init i18n (before anything renders) ──────────────────────
(0, $dA2FI.initI18n)();
[
    "lang-switcher-nav",
    "lang-switcher-footer"
].forEach((id)=>{
    const el = document.getElementById(id);
    if (el) el.appendChild((0, $dA2FI.createSwitcher)());
});
// Re-render panel description when lang changes
document.addEventListener("langchange", ()=>{
    (0, $dA2FI.applyTranslations)();
    // Update project count string
    const countEl = document.getElementById("project-count");
    if (countEl && countEl.dataset.total) {
        const total = parseInt(countEl.dataset.total, 10);
        countEl.textContent = `\u{2014} ${total} ${(0, $dA2FI.t)(total > 1 ? "pg.count.plural" : "pg.count.singular")}`;
    }
    // Re-render open panel if any
    const panel = document.getElementById("project-panel");
    if (panel && panel.classList.contains("open") && window.__openedProject) {
        const descEl = document.getElementById("panel-description");
        if (descEl) {
            const proj = window.__openedProject;
            const desc = (0, $dA2FI.getLang)() === "en" && (0, $dA2FI.PROJECT_DESC_EN)[proj.name] ? (0, $dA2FI.PROJECT_DESC_EN)[proj.name] : proj.description;
            descEl.textContent = desc || (0, $dA2FI.t)("panel.fallback");
        }
    }
});
var $090ea0cfecc46051$exports = {};
$090ea0cfecc46051$exports = new URL("../video/1.2c681a5c.mp4", import.meta.url).toString();


var $3f9a07d275ac9b0c$exports = {};
$3f9a07d275ac9b0c$exports = new URL("../2.794094d1.avif", import.meta.url).toString();


var $7e8dd298d443f3c3$exports = {};
$7e8dd298d443f3c3$exports = new URL("../3.2384d99b.avif", import.meta.url).toString();


var $a6c7183c2500d7f1$exports = {};
$a6c7183c2500d7f1$exports = new URL("../4.a1e994d8.avif", import.meta.url).toString();






var $f514b2f40e4bc171$exports = {};
$f514b2f40e4bc171$exports = new URL("../5.8f79d0ed.avif", import.meta.url).toString();


var $ce310b6e9e16109e$exports = {};
$ce310b6e9e16109e$exports = new URL("../video/1.26ee181a.mp4", import.meta.url).toString();


var $9875301c6c05bd97$exports = {};
$9875301c6c05bd97$exports = new URL("../2.50fd14e1.avif", import.meta.url).toString();


var $f8dc9ae4240aca20$exports = {};
$f8dc9ae4240aca20$exports = new URL("../3.36ce83f9.avif", import.meta.url).toString();


var $6c095a565dcfeccd$exports = {};
$6c095a565dcfeccd$exports = new URL("../4.0a7f2b40.avif", import.meta.url).toString();






var $fe6d2f19ef3ba6d9$exports = {};
$fe6d2f19ef3ba6d9$exports = new URL("../5.d6faed60.avif", import.meta.url).toString();


var $0e8ac51dfabb5abb$exports = {};
$0e8ac51dfabb5abb$exports = new URL("../video/1.eceb7ea7.mp4", import.meta.url).toString();


var $f2c114a80467957a$exports = {};
$f2c114a80467957a$exports = new URL("../video/2.9a90f0ea.mp4", import.meta.url).toString();


var $249bc1985deff01a$exports = {};
$249bc1985deff01a$exports = new URL("../video/4.087c57a7.mp4", import.meta.url).toString();


var $af58a298b611781a$exports = {};
$af58a298b611781a$exports = new URL("../5.99027ff1.avif", import.meta.url).toString();






var $e3671ee763bba607$exports = {};
$e3671ee763bba607$exports = new URL("../video/1.5d84e25b.mp4", import.meta.url).toString();


var $2bbe3e523591d0d6$exports = {};
$2bbe3e523591d0d6$exports = new URL("../2.c312a7bd.avif", import.meta.url).toString();


var $1390d4172fc15339$exports = {};
$1390d4172fc15339$exports = new URL("../3.f4c1d155.avif", import.meta.url).toString();


var $445c56b755abda8c$exports = {};
$445c56b755abda8c$exports = new URL("../video/4.eeed2be4.mp4", import.meta.url).toString();






var $8be5bbf7faca9685$exports = {};
$8be5bbf7faca9685$exports = new URL("../video/1.4f7082c5.mp4", import.meta.url).toString();


var $26c70eb10e1fc8f8$exports = {};
$26c70eb10e1fc8f8$exports = new URL("../2.b2bb4aac.avif", import.meta.url).toString();


var $6aa0ccad7f4b4080$exports = {};
$6aa0ccad7f4b4080$exports = new URL("../3.c441c4c3.avif", import.meta.url).toString();


var $f38574e742ce3993$exports = {};
$f38574e742ce3993$exports = new URL("../4.263d29b5.avif", import.meta.url).toString();






var $757679ddc279631f$exports = {};
$757679ddc279631f$exports = new URL("../video/1.8e96626d.mp4", import.meta.url).toString();


var $18b2d16be3b17e9a$exports = {};
$18b2d16be3b17e9a$exports = new URL("../2.e226121c.avif", import.meta.url).toString();


var $05f1d8a98d0dc5de$exports = {};
$05f1d8a98d0dc5de$exports = new URL("../3.ba379d88.avif", import.meta.url).toString();





var $8aadcbca73b111aa$exports = {};
$8aadcbca73b111aa$exports = new URL("../1.34f0b34c.avif", import.meta.url).toString();


var $e0d14b50df3beca8$exports = {};
$e0d14b50df3beca8$exports = new URL("../video/2.5b4338be.mp4", import.meta.url).toString();


var $0100462506f76bb0$exports = {};
$0100462506f76bb0$exports = new URL("../3.f62312f8.avif", import.meta.url).toString();


var $c556188222d4e724$exports = {};
$c556188222d4e724$exports = new URL("../4.6b37642d.avif", import.meta.url).toString();






var $ec7983959e61bc5e$exports = {};
$ec7983959e61bc5e$exports = new URL("../5.d6ef431f.avif", import.meta.url).toString();


var $b35e5303b725e962$exports = {};
$b35e5303b725e962$exports = new URL("../1.638d3d41.avif", import.meta.url).toString();


var $1788b4f3fc20ab06$exports = {};
$1788b4f3fc20ab06$exports = new URL("../2.22e17e30.avif", import.meta.url).toString();


var $b4bdb3900d2a4303$exports = {};
$b4bdb3900d2a4303$exports = new URL("../3.43dc099b.avif", import.meta.url).toString();





var $3c95f8af0f4a016c$exports = {};
$3c95f8af0f4a016c$exports = new URL("../1.7b3066b6.avif", import.meta.url).toString();


var $d171af06643be6f1$exports = {};
$d171af06643be6f1$exports = new URL("../2.3ba73651.avif", import.meta.url).toString();


var $bcb277ca9041f9db$exports = {};
$bcb277ca9041f9db$exports = new URL("../3.3c7b295b.avif", import.meta.url).toString();


var $9ccd244f1703f721$exports = {};
$9ccd244f1703f721$exports = new URL("../4.f69503b0.avif", import.meta.url).toString();






var $0317a1b6c473102e$exports = {};
$0317a1b6c473102e$exports = new URL("../5.fdae10f4.avif", import.meta.url).toString();


var $5ee668f4ce906408$exports = {};
$5ee668f4ce906408$exports = new URL("../video/1.bbdfb4f7.mp4", import.meta.url).toString();


var $fd7e3080552d9bb6$exports = {};
$fd7e3080552d9bb6$exports = new URL("../2.e0fdd048.avif", import.meta.url).toString();


var $fed1ae40719637a4$exports = {};
$fed1ae40719637a4$exports = new URL("../3.e1cd8d21.avif", import.meta.url).toString();





var $d74030042c3405e6$exports = {};
$d74030042c3405e6$exports = new URL("../video/0.202eafe6.mp4", import.meta.url).toString();


var $75b3c2e0f9019bdd$exports = {};
$75b3c2e0f9019bdd$exports = new URL("../2.c1ac4dd3.avif", import.meta.url).toString();


var $80534e49763ca32a$exports = {};
$80534e49763ca32a$exports = new URL("../3.eaad3db6.avif", import.meta.url).toString();


var $c3f3ec40731775b8$exports = {};
$c3f3ec40731775b8$exports = new URL("../4.327c4c88.avif", import.meta.url).toString();



var $62db45d7a6d9537f$exports = {};
$62db45d7a6d9537f$exports = new URL("../1.a0ec1fdb.avif", import.meta.url).toString();





var $a0730ffa63e0a2b1$exports = {};
$a0730ffa63e0a2b1$exports = new URL("../5.09f687e7.avif", import.meta.url).toString();


var $6b30df5039256ac5$exports = {};
$6b30df5039256ac5$exports = new URL("../video/1.fb1c6f37.mp4", import.meta.url).toString();


var $f8f86a90a8b6e98b$exports = {};
$f8f86a90a8b6e98b$exports = new URL("../2.634ad9d6.avif", import.meta.url).toString();


var $dd40e97362465e3b$exports = {};
$dd40e97362465e3b$exports = new URL("../3.7d0c6766.avif", import.meta.url).toString();


var $149fa68f1e59f3ea$exports = {};
$149fa68f1e59f3ea$exports = new URL("../4.af291b5c.avif", import.meta.url).toString();






var $4cdca1f7ed6d326b$exports = {};
$4cdca1f7ed6d326b$exports = new URL("../video/1.16f743cc.mp4", import.meta.url).toString();


var $26d95aa6ef2b0609$exports = {};
$26d95aa6ef2b0609$exports = new URL("../2.d5f6ccbe.avif", import.meta.url).toString();


var $a762aa3f1346035a$exports = {};
$a762aa3f1346035a$exports = new URL("../3.50825942.avif", import.meta.url).toString();


var $fa9366258702f1d0$exports = {};
$fa9366258702f1d0$exports = new URL("../4.55470f8b.avif", import.meta.url).toString();






var $f5d8f747b8839513$exports = {};
$f5d8f747b8839513$exports = new URL("../1.feffc330.avif", import.meta.url).toString();


var $29f40201d40789ac$exports = {};
$29f40201d40789ac$exports = new URL("../2.4b1f257a.avif", import.meta.url).toString();


var $2c6dd88ba745a444$exports = {};
$2c6dd88ba745a444$exports = new URL("../3.2b83dba9.avif", import.meta.url).toString();


var $89863f9018b64f16$exports = {};
$89863f9018b64f16$exports = new URL("../4.cddfa4ee.avif", import.meta.url).toString();






var $37f5e819976c91c7$exports = {};
$37f5e819976c91c7$exports = new URL("../5.8f79c768.avif", import.meta.url).toString();


// ═══════════════════════════════════════════════════════════════
// ██  PROJETS  ██  Ajoute tes projets ici, un bloc par projet
// ═══════════════════════════════════════════════════════════════
//
// Chaque projet a :
//   thumb        → image/vidéo principale affichée dans la grille
//   thumbType    → "image" ou "video"
//   category     → "web" | "video" | "photo"  (utilisé par le filtre)
//   name         → nom affiché au survol et dans le panneau
//   skills       → liste de compétences affichées dans le panneau
//   presentation → phrase d'accroche (panneau)
//   description  → texte long (panneau)
//   gallery      → images/vidéos affichées dans les cellules autour du projet
//                  (entre 1 et 5, type "image" ou "video")
//
// ── Pour ajouter un projet : copie un bloc { ... }, et colle-le
//    à la suite. Change les fichiers et les textes. C'est tout.
// ═══════════════════════════════════════════════════════════════
const $54b47fc030b7b21e$var$PROJECTS = [
    // ── Projet 1 — La Galerie des Souvenirs ──────────────────────
    {
        // Cellule principale dans la grille (image 1 = vidéo)
        thumb: new URL($090ea0cfecc46051$exports).href,
        thumbType: "video",
        category: "web",
        name: "La Galerie des Souvenirs",
        year: "2026",
        skills: [
            "GSAP",
            "JavaScript",
            "Figma",
            "Notion",
            "Claude AI",
            "Illustrator",
            "Photoshop"
        ],
        description: "La Galerie des Souvenirs a \xe9t\xe9, pour moi, de loin le projet le plus ambitieux que j'ai pu r\xe9aliser \xe0 l'\xe9cole. Ce projet est appel\xe9 le Projet S6 car il repr\xe9sente le 6\xe8me semestre de la formation. Il s'est d\xe9roul\xe9 sur plusieurs mois avec un th\xe8me commun pour tout le monde : [Hors-Contr\xf4le]. J'ai d\xe9cid\xe9 de partir sur un site repr\xe9sentant un mus\xe9e interactif afin de raconter l'histoire de l'artiste William Utermohlen et de sa perte de contr\xf4le face \xe0 la maladie d'Alzheimer. Mon site retrace toute son histoire, de sa naissance \xe0 sa mort, en passant par les diff\xe9rentes p\xe9riodes de sa vie, jusqu'\xe0 l'apparition des premiers sympt\xf4mes de la maladie. Je suis tr\xe8s fier de ce projet, qui m'a valu la mention excellent lors des rendus. Je pr\xe9vois aussi de le pr\xe9senter aux concours Awwwards ou SiteInspire en 2027. Un stand et une affiche ont aussi d\xfb \xeatre cr\xe9\xe9s \xe0 cette occasion afin de pr\xe9senter nos travaux \xe0 des agences, \xe0 des particuliers ainsi qu'aux autres \xe9l\xe8ves de l'\xe9cole, lors d'une soir\xe9e portes ouvertes sp\xe9cialement consacr\xe9e au projet S6.",
        links: [
            {
                label: "Voir le site",
                url: "https://galerie-souvenirs.cordy-maxime.ch/"
            },
            {
                label: "Voir sur Figma",
                url: "https://www.figma.com/design/6hIgtcamjZcU2HR5HYQ2st/Design---Wireframe?node-id=0-1&t=3DjtesAmEmtURarZ-1"
            },
            {
                label: "GitHub",
                url: "https://github.com/MaximeCordy/S6Code"
            }
        ],
        // hoverMedia = images 2 et 3 affichées dans les cellules autour de la grille
        hoverMedia: [
            {
                src: new URL($3f9a07d275ac9b0c$exports).href,
                type: "image"
            },
            {
                src: new URL($7e8dd298d443f3c3$exports).href,
                type: "image"
            },
            {
                src: new URL($a6c7183c2500d7f1$exports).href,
                type: "image"
            }
        ],
        // gallery = panel slider seulement (images 1→5, images 4 et 5 uniquement ici)
        gallery: [
            {
                src: new URL($090ea0cfecc46051$exports).href,
                type: "video"
            },
            {
                src: new URL($3f9a07d275ac9b0c$exports).href,
                type: "image"
            },
            {
                src: new URL($7e8dd298d443f3c3$exports).href,
                type: "image"
            },
            {
                src: new URL($a6c7183c2500d7f1$exports).href,
                type: "image"
            },
            {
                src: new URL($f514b2f40e4bc171$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 2 — Vitamin Well ───────────────────────────────────
    {
        thumb: new URL($ce310b6e9e16109e$exports).href,
        thumbType: "video",
        category: "video",
        name: "Vitamin Well",
        year: "2024",
        skills: [
            "Premiere Pro",
            "After Effects",
            "FX-30",
            "Drone"
        ],
        description: "Cette vid\xe9o est un projet qui me tient \xe0 c\u0153ur, tant pour sa qualit\xe9 que pour les efforts endur\xe9s afin de la cr\xe9er. Le but de ce projet \xe9tait de r\xe9aliser une publicit\xe9 fictive pour la marque de boissons vitamin\xe9es [Vitamin Well]. L'ambiance ressentie dans cette vid\xe9o nous fait vivre l'effort et la fatigue durant une course, qui nous m\xe8ne \xe0 une hydratation bien m\xe9rit\xe9e. Le tout est pr\xe9sent\xe9 dans une atmosph\xe8re froide et nuageuse, renfor\xe7ant la sensation d'effort et de d\xe9passement de soi. Cr\xe9dits : Andr\xe9a Iacoviello, Magnolia Occhipinti, Maxime Cordy",
        links: [
            {
                label: "Voir sur YouTube",
                url: "https://youtu.be/_S8RCfiYGuk"
            }
        ],
        hoverMedia: [
            {
                src: new URL($9875301c6c05bd97$exports).href,
                type: "image"
            },
            {
                src: new URL($f8dc9ae4240aca20$exports).href,
                type: "image"
            },
            {
                src: new URL($6c095a565dcfeccd$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($ce310b6e9e16109e$exports).href,
                type: "video"
            },
            {
                src: new URL($9875301c6c05bd97$exports).href,
                type: "image"
            },
            {
                src: new URL($f8dc9ae4240aca20$exports).href,
                type: "image"
            },
            {
                src: new URL($6c095a565dcfeccd$exports).href,
                type: "image"
            },
            {
                src: new URL($fe6d2f19ef3ba6d9$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 3 — Ciné Gusto ─────────────────────────────────────
    {
        thumb: new URL($0e8ac51dfabb5abb$exports).href,
        thumbType: "video",
        category: "web",
        name: "Cin\xe9 Gusto",
        year: "2026",
        skills: [
            "Figma",
            "After Effects",
            "Notion",
            "Photoshop",
            "Illustrator"
        ],
        links: [
            {
                label: "Voir sur Figma",
                url: "https://www.figma.com/design/EY4Kay3rBma8YhyQzfOs8N/CINEGUSTO?node-id=232-191&t=ZrKe4GnAdMZUzdCn-1"
            }
        ],
        description: "Cin\xe9 Gusto a \xe9t\xe9 mon dernier gros projet de fin de formation. Pour cet examen de TPI, j'ai d\xfb choisir et cr\xe9er trois supports dans le but de promouvoir un festival m\xealant le cin\xe9ma, la gastronomie et la transculturalit\xe9. J'ai d\xe9cid\xe9 de r\xe9aliser une maquette de landing page en one-page, une vid\xe9o de signal\xe9tique diffus\xe9e sur les diff\xe9rents emplacements physiques du festival, ainsi qu'un logo d'application mettant en avant une plateforme VOD regroupant tous les films et recettes du festival. Apr\xe8s mon analyse marketing, j'ai commenc\xe9 par cr\xe9er une direction artistique dans un style minimaliste afin d'aller directement \xe0 l'essentiel. Une touche de halftone appliqu\xe9e aux affiches de films rappelle l'univers du cin\xe9ma, tandis que la nourriture, pr\xe9sent\xe9e sous forme de packshots aux couleurs satur\xe9es, ouvre l'app\xe9tit. Le r\xe9sultat de ce projet a \xe9t\xe9 pr\xe9sent\xe9 pendant 30 minutes devant des experts du domaine. J'en suis satisfait, m\xeame si j'aurais aim\xe9 y consacrer davantage de temps afin de peaufiner certains d\xe9tails. Cr\xe9dits : Maxime Cordy",
        hoverMedia: [
            {
                src: new URL($f2c114a80467957a$exports).href,
                type: "video"
            },
            {
                src: new URL($249bc1985deff01a$exports).href,
                type: "video"
            },
            {
                src: new URL($af58a298b611781a$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($0e8ac51dfabb5abb$exports).href,
                type: "video"
            },
            {
                src: new URL($f2c114a80467957a$exports).href,
                type: "video"
            },
            {
                src: new URL($249bc1985deff01a$exports).href,
                type: "video"
            },
            {
                src: new URL($af58a298b611781a$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 4 — SEUL ───────────────────────────────────────────
    {
        thumb: new URL($e3671ee763bba607$exports).href,
        thumbType: "video",
        category: "video",
        name: "SEUL",
        year: "2024",
        skills: [
            "Premiere Pro",
            "After Effects",
            "FX-30"
        ],
        links: [
            {
                label: "Voir sur YouTube",
                url: "https://youtu.be/vXne_YaWgCs"
            }
        ],
        description: "[SEUL] est un court-m\xe9trage fictif r\xe9alis\xe9 de A \xe0 Z avec quatre autres camarades de classe et un acteur. Cette fiction, mise en avant au NiFFF (Neuch\xe2tel International Fantastic Film Festival), met en sc\xe8ne un homme vivant dans son chalet, \xe0 l'abri de toute pr\xe9sence humaine, perturb\xe9 par une pr\xe9sence \xe9trange qui le tourmente. Cette vid\xe9o a \xe9t\xe9 tourn\xe9e dans mon chalet familial avec du mat\xe9riel professionnel pr\xeat\xe9 par mon ancienne \xe9cole, [eikon]. Une seule journ\xe9e de tournage a suffi gr\xe2ce \xe0 un storyboard complet et pr\xe9cis. Le montage a ensuite \xe9t\xe9 r\xe9parti entre nous quatre, chacun \xe9tant responsable d'un domaine sp\xe9cifique, comme le son, la musique, la colorim\xe9trie, le montage ou encore les effets r\xe9alis\xe9s sur After Effects.",
        hoverMedia: [
            {
                src: new URL($2bbe3e523591d0d6$exports).href,
                type: "image"
            },
            {
                src: new URL($1390d4172fc15339$exports).href,
                type: "image"
            },
            {
                src: new URL($445c56b755abda8c$exports).href,
                type: "video"
            }
        ],
        gallery: [
            {
                src: new URL($e3671ee763bba607$exports).href,
                type: "video"
            },
            {
                src: new URL($2bbe3e523591d0d6$exports).href,
                type: "image"
            },
            {
                src: new URL($1390d4172fc15339$exports).href,
                type: "image"
            },
            {
                src: new URL($445c56b755abda8c$exports).href,
                type: "video"
            }
        ]
    },
    // ── Projet 5 — Muay Thaï ──────────────────────────────────────
    {
        thumb: new URL($8be5bbf7faca9685$exports).href,
        thumbType: "video",
        category: "video",
        name: "Muay Tha\xef",
        year: "2025",
        skills: [
            "Premiere Pro",
            "After Effects",
            "R8"
        ],
        links: [
            {
                label: "Voir sur YouTube",
                url: "https://youtu.be/LN4GW57PCZo"
            }
        ],
        description: "Mon ami Nico a gentiment accept\xe9 que nous tournions un documentaire dans la salle de sport o\xf9 il s'entra\xeenait au Muay Tha\xef. Ce documentaire le suit tout au long de son entra\xeenement, en alternant avec une interview face cam\xe9ra dans laquelle il r\xe9pond \xe0 des questions sur son lien avec ce sport, les raisons pour lesquelles il l'appr\xe9cie, et invite les gens \xe0 le d\xe9couvrir et \xe0 le pratiquer. Cr\xe9dits : Magnolia Occhipinti, Maxime Cordy, Nicola Cleusix",
        hoverMedia: [
            {
                src: new URL($26c70eb10e1fc8f8$exports).href,
                type: "image"
            },
            {
                src: new URL($6aa0ccad7f4b4080$exports).href,
                type: "image"
            },
            {
                src: new URL($f38574e742ce3993$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($8be5bbf7faca9685$exports).href,
                type: "video"
            },
            {
                src: new URL($26c70eb10e1fc8f8$exports).href,
                type: "image"
            },
            {
                src: new URL($6aa0ccad7f4b4080$exports).href,
                type: "image"
            },
            {
                src: new URL($f38574e742ce3993$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 6 — Sabre ──────────────────────────────────────────
    {
        thumb: new URL($757679ddc279631f$exports).href,
        thumbType: "video",
        category: "web",
        name: "Sabre",
        year: "2025",
        skills: [
            "GSAP",
            "JavaScript",
            "Figma",
            "Illustrator",
            "Photoshop"
        ],
        links: [
            {
                label: "Voir le site",
                url: "https://maxime-cordy.at-eikon.ch/sabre/"
            },
            {
                label: "GitHub",
                url: "https://github.com/MaximeCordy/storytelling_sabre"
            }
        ],
        description: "Sabre est un roman graphique \xe9crit par \xc9ric Feres qui suit l'histoire d'un petit tigre pas comme les autres. Le mandat fictif re\xe7u par Eikon nous demandait de cr\xe9er un site de storytelling afin de promouvoir le livre Sabre. \xc0 l'aide de deux de mes coll\xe8gues, nous avons r\xe9imagin\xe9 cette histoire pour transmettre des informations et des \xe9motions aux personnes d\xe9couvrant ce site, mettant ainsi en avant cette \u0153uvre. Le tout apr\xe8s beaucoup de r\xe9flexion, de lecture et de code ! Cr\xe9dits : Andr\xe9a Iacoviello, Tilio Pezzoli, Maxime Cordy",
        hoverMedia: [
            {
                src: new URL($18b2d16be3b17e9a$exports).href,
                type: "image"
            },
            {
                src: new URL($05f1d8a98d0dc5de$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($757679ddc279631f$exports).href,
                type: "video"
            },
            {
                src: new URL($18b2d16be3b17e9a$exports).href,
                type: "image"
            },
            {
                src: new URL($05f1d8a98d0dc5de$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 7 — Harlem ─────────────────────────────────────────
    {
        thumb: new URL($8aadcbca73b111aa$exports).href,
        thumbType: "image",
        category: "web",
        name: "Harlem",
        year: "2026",
        skills: [
            "Figma",
            "Claude Code"
        ],
        links: [
            {
                label: "Voir le site",
                url: "https://harlem.cordy-maxime.ch/"
            },
            {
                label: "GitHub",
                url: "https://github.com/MaximeCordy/Harlem-code"
            }
        ],
        description: "Ce site est une exception parmi les autres. Pour un projet d'histoire de l'art, nous devions cr\xe9er un support interactif pr\xe9sentant cinq \u0153uvres d'art ayant un lien entre elles. Vu le manque de temps \xe0 disposition, j'ai d\xe9cid\xe9 de cr\xe9er une maquette sur Figma d'une landing page. Par la suite, j'ai d\xe9cid\xe9 d'utiliser Claude Code et Claude (en mode Cowork) pour r\xe9aliser un site en scroll infini compos\xe9 de plusieurs sections explicatives. Cr\xe9dits : Maxime Cordy",
        hoverMedia: [
            {
                src: new URL($e0d14b50df3beca8$exports).href,
                type: "video"
            },
            {
                src: new URL($0100462506f76bb0$exports).href,
                type: "image"
            },
            {
                src: new URL($c556188222d4e724$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($8aadcbca73b111aa$exports).href,
                type: "image"
            },
            {
                src: new URL($e0d14b50df3beca8$exports).href,
                type: "video"
            },
            {
                src: new URL($0100462506f76bb0$exports).href,
                type: "image"
            },
            {
                src: new URL($c556188222d4e724$exports).href,
                type: "image"
            },
            {
                src: new URL($ec7983959e61bc5e$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 8 — Affiches ───────────────────────────────────────
    {
        thumb: new URL($b35e5303b725e962$exports).href,
        thumbType: "image",
        category: "photo",
        name: "Affiches",
        year: "2023 \u2013 2025",
        skills: [
            "Illustrator",
            "Photoshop"
        ],
        description: "Voici trois affiches que j'ai pu r\xe9aliser au fil des ann\xe9es. La premi\xe8re fut mon premier mandat professionnel pour le festival fribourgeois Juvenalia. Celui-ci m'a permis d'\xeatre \xe0 l'\xe9coute des envies de l'organisation et de rester en lien avec elle tout au long du processus de cr\xe9ation. Une tr\xe8s bonne exp\xe9rience. Les deux autres affiches ont \xe9t\xe9 r\xe9alis\xe9es dans le cadre de mes cours, pour deux projets diff\xe9rents : la premi\xe8re pour le festival Les Georges, \xe9galement \xe0 Fribourg, et la seconde est une affiche informative sur les langues parl\xe9es en Suisse. Elle met en avant une photographie r\xe9alis\xe9e par un camarade et moi-m\xeame, repr\xe9sentant un jeune enfant criant les diff\xe9rentes langues \xe0 travers des dessins enfantins. Cr\xe9dits : Maxime Cordy",
        hoverMedia: [
            {
                src: new URL($1788b4f3fc20ab06$exports).href,
                type: "image"
            },
            {
                src: new URL($b4bdb3900d2a4303$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($b35e5303b725e962$exports).href,
                type: "image"
            },
            {
                src: new URL($1788b4f3fc20ab06$exports).href,
                type: "image"
            },
            {
                src: new URL($b4bdb3900d2a4303$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 11 — Retraite ──────────────────────────────────────
    {
        thumb: new URL($3c95f8af0f4a016c$exports).href,
        thumbType: "image",
        category: "photo",
        name: "Retraite",
        year: "2023",
        skills: [
            "Photographie",
            "Sony A6700"
        ],
        description: "Pour cette s\xe9rie d'images sur le th\xe8me de la retraite, ma grand-m\xe8re a gentiment accept\xe9 de poser pendant ses activit\xe9s sportives favorites. L'objectif \xe9tait de dresser le portrait d'une retrait\xe9e active et de montrer qu'une retraite \xe9panouie peut rimer avec dynamisme, mouvement et passion. Cr\xe9dits : Maxime Cordy, Micheline Nanchen",
        hoverMedia: [
            {
                src: new URL($d171af06643be6f1$exports).href,
                type: "image"
            },
            {
                src: new URL($bcb277ca9041f9db$exports).href,
                type: "image"
            },
            {
                src: new URL($9ccd244f1703f721$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($3c95f8af0f4a016c$exports).href,
                type: "image"
            },
            {
                src: new URL($d171af06643be6f1$exports).href,
                type: "image"
            },
            {
                src: new URL($bcb277ca9041f9db$exports).href,
                type: "image"
            },
            {
                src: new URL($9ccd244f1703f721$exports).href,
                type: "image"
            },
            {
                src: new URL($0317a1b6c473102e$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 9 — Jaguar ─────────────────────────────────────────
    {
        thumb: new URL($5ee668f4ce906408$exports).href,
        thumbType: "video",
        category: "video",
        name: "Jaguar",
        year: "2023",
        skills: [
            "Premiere Pro",
            "R8",
            "After Effects"
        ],
        links: [
            {
                label: "Voir sur YouTube",
                url: "https://youtu.be/Oz0BNxmVqtk"
            }
        ],
        description: "Cette vid\xe9o fut ma premi\xe8re vid\xe9o \xe0 avoir \xe9t\xe9 tourn\xe9e au sein de l'\xe9cole. Une pub fictive faisant la promotion de deux Jaguar Type E, \xe9voluant dans diff\xe9rents environnements, se cherchant d\xe9sesp\xe9r\xe9ment sur les routes de Suisse pour finir par se retrouver \xe0 la fin. Deux jours de tournage en ext\xe9rieur avec deux vieilles voitures ont d\xfb \xeatre pr\xe9vus. Une vid\xe9o tourn\xe9e avec mon p\xe8re et ma copine. Cr\xe9dits : Maxime Cordy, Walter Cordy",
        hoverMedia: [
            {
                src: new URL($fd7e3080552d9bb6$exports).href,
                type: "image"
            },
            {
                src: new URL($fed1ae40719637a4$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($5ee668f4ce906408$exports).href,
                type: "video"
            },
            {
                src: new URL($fd7e3080552d9bb6$exports).href,
                type: "image"
            },
            {
                src: new URL($fed1ae40719637a4$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 12 — Bota Bota ────────────────────────────────────
    {
        thumb: new URL($d74030042c3405e6$exports).href,
        thumbType: "video",
        category: "web",
        name: "Bota Bota",
        year: "2026",
        skills: [
            "Illustrator",
            "Figma",
            "Photoshop"
        ],
        description: "Ce projet de design graphique m'a permis de me plonger dans un rebranding fictif complet du Jardin botanique de Fribourg. L'id\xe9e \xe9tait de reprendre les bases de l'identit\xe9 existante afin d'en faire une marque plus moderne, dans le but de favoriser la venue des visiteurs. Nous nous sommes d'abord pench\xe9s sur la d\xe9finition d'un style graphique adapt\xe9, avant de r\xe9aliser les diff\xe9rentes maquettes. Une id\xe9e m'est venue en observant la forme du jardin sur Google Maps. Celle-ci \xe9tait id\xe9ale pour cr\xe9er un logo faisant le lien entre la symbolique de la nature, repr\xe9sent\xe9e par les cernes d'un tronc d'arbre, et la conception harmonieuse du Jardin botanique. Ce concept permet ainsi de refl\xe9ter \xe0 la fois l'identit\xe9 du lieu et son organisation unique. Cr\xe9dits : Maxime Cordy, Tilio Pezzoli",
        hoverMedia: [
            {
                src: new URL($75b3c2e0f9019bdd$exports).href,
                type: "image"
            },
            {
                src: new URL($80534e49763ca32a$exports).href,
                type: "image"
            },
            {
                src: new URL($c3f3ec40731775b8$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($d74030042c3405e6$exports).href,
                type: "video"
            },
            {
                src: new URL($62db45d7a6d9537f$exports).href,
                type: "image"
            },
            {
                src: new URL($75b3c2e0f9019bdd$exports).href,
                type: "image"
            },
            {
                src: new URL($80534e49763ca32a$exports).href,
                type: "image"
            },
            {
                src: new URL($c3f3ec40731775b8$exports).href,
                type: "image"
            },
            {
                src: new URL($a0730ffa63e0a2b1$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 13 — Is There Anybody Out There? ──────────────────
    {
        thumb: new URL($6b30df5039256ac5$exports).href,
        thumbType: "video",
        category: "video",
        name: "Is There Anybody Out There ?",
        year: "2026",
        skills: [
            "Premiere Pro",
            "After Effects"
        ],
        links: [
            {
                label: "Voir sur YouTube",
                url: "https://youtu.be/MMjPSG9v6eg"
            }
        ],
        description: 'Un clip musical r\xe9alis\xe9 sur la chanson "Is There Anybody Out There ?" de Pink Floyd, issue de l\'album "The Wall". Le projet met en sc\xe8ne un jeune homme tourment\xe9, enferm\xe9 dans ses pens\xe9es, se demandant s\'il existe encore une pr\xe9sence autour de lui. En parall\xe8le, des images de nature d\xe9pourvues de toute trace de vie humaine illustrent un monde ext\xe9rieur silencieux, cr\xe9ant une ambigu\xeft\xe9 entre la r\xe9alit\xe9, la perception et la possible folie du personnage. Cr\xe9dits : Maxime Cordy, Tilio Pezzoli, Andr\xe9a Iacoviello',
        hoverMedia: [
            {
                src: new URL($f8f86a90a8b6e98b$exports).href,
                type: "image"
            },
            {
                src: new URL($dd40e97362465e3b$exports).href,
                type: "image"
            },
            {
                src: new URL($149fa68f1e59f3ea$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($6b30df5039256ac5$exports).href,
                type: "video"
            },
            {
                src: new URL($f8f86a90a8b6e98b$exports).href,
                type: "image"
            },
            {
                src: new URL($dd40e97362465e3b$exports).href,
                type: "image"
            },
            {
                src: new URL($149fa68f1e59f3ea$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 14 — SABRE Animation ──────────────────────────────
    {
        thumb: new URL($4cdca1f7ed6d326b$exports).href,
        thumbType: "video",
        category: "video",
        name: "SABRE Animation",
        year: "2025",
        skills: [
            "Photoshop",
            "After Effects"
        ],
        links: [
            {
                label: "Voir sur YouTube",
                url: "https://youtu.be/Jl3SyMYfy0s"
            }
        ],
        description: "Cette animation est la suite du projet web \"SABRE\". Elle reprend l'univers graphique du site pour cr\xe9er une s\xe9quence anim\xe9e immersive, m\xealant motion design et identit\xe9 visuelle forte. Le projet explore les possibilit\xe9s narratives de l'animation dans le cadre d'une identit\xe9 de marque. Cr\xe9dits : Maxime Cordy, Tilio Pezzoli, Andr\xe9a Iacoviello",
        hoverMedia: [
            {
                src: new URL($26d95aa6ef2b0609$exports).href,
                type: "image"
            },
            {
                src: new URL($a762aa3f1346035a$exports).href,
                type: "image"
            },
            {
                src: new URL($fa9366258702f1d0$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($4cdca1f7ed6d326b$exports).href,
                type: "video"
            },
            {
                src: new URL($26d95aa6ef2b0609$exports).href,
                type: "image"
            },
            {
                src: new URL($a762aa3f1346035a$exports).href,
                type: "image"
            },
            {
                src: new URL($fa9366258702f1d0$exports).href,
                type: "image"
            }
        ]
    },
    // ── Projet 10 — Croatie ───────────────────────────────────────
    {
        thumb: new URL($f5d8f747b8839513$exports).href,
        thumbType: "image",
        category: "photo",
        name: "Croatie",
        year: "2024",
        skills: [
            "Photographie",
            "Sony A6700"
        ],
        description: "J'aime la photographie, que ce soit de nature, en studio ou en portrait. Ces clich\xe9s viennent tout droit de Croatie, captur\xe9s avec mon Sony A6700 sur l'\xeele de Komi\u017Ea. Le but \xe9tait de cr\xe9er une s\xe9rie de photos repr\xe9sentant les vacances \xe0 la plage, avec une approche nostalgique. Cr\xe9dits : Maxime Cordy",
        hoverMedia: [
            {
                src: new URL($29f40201d40789ac$exports).href,
                type: "image"
            },
            {
                src: new URL($2c6dd88ba745a444$exports).href,
                type: "image"
            },
            {
                src: new URL($89863f9018b64f16$exports).href,
                type: "image"
            }
        ],
        gallery: [
            {
                src: new URL($f5d8f747b8839513$exports).href,
                type: "image"
            },
            {
                src: new URL($29f40201d40789ac$exports).href,
                type: "image"
            },
            {
                src: new URL($2c6dd88ba745a444$exports).href,
                type: "image"
            },
            {
                src: new URL($89863f9018b64f16$exports).href,
                type: "image"
            },
            {
                src: new URL($37f5e819976c91c7$exports).href,
                type: "image"
            }
        ]
    }
];
// ── Dérivation automatique (ne pas modifier) ──────────────────
const $54b47fc030b7b21e$var$MEDIA = $54b47fc030b7b21e$var$PROJECTS.map((p)=>({
        src: p.thumb,
        type: p.thumbType,
        category: p.category,
        name: p.name,
        year: p.year,
        skills: p.skills,
        presentation: p.presentation,
        description: p.description,
        mediaCaption: p.name
    }));
// Les images de gap sont maintenant gérées projet par projet (hoverMedia ou gallery),
// directement dans makeCell() — plus de pool global HOVER_MEDIA.
// ── Page transition ───────────────────────────────────────────
const $54b47fc030b7b21e$var$PageTransition = (()=>{
    const N_BANDS = 4;
    const ENTER_DUR = 500;
    const EXIT_DUR = 550;
    const STAGGER = 60;
    const container = document.getElementById("page-transition");
    let bands = [];
    let rafId = null;
    const easeOutExpo = (t)=>t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    const easeInExpo = (t)=>t === 0 ? 0 : Math.pow(2, 10 * t - 10);
    function buildBands(startCovered) {
        container.querySelectorAll(".pt-band").forEach((el)=>el.remove());
        bands = [];
        const W = window.innerWidth;
        const bandH = window.innerHeight / N_BANDS;
        for(let i = 0; i < N_BANDS; i++){
            const el = document.createElement("div");
            el.className = "pt-band";
            el.style.top = `${i * bandH}px`;
            el.style.height = `${bandH + 1}px`;
            if (startCovered) el.style.transform = `translateX(${W + 4}px)`;
            container.appendChild(el);
            bands.push(el);
        }
    }
    // Bands sweep IN → when fully covered → onCovered()
    function enter(onCovered) {
        if (rafId) return;
        buildBands(false);
        container.classList.add("active");
        const W = window.innerWidth;
        const COVERED_AT = ENTER_DUR + (N_BANDS - 1) * STAGGER;
        let called = false;
        const startTs = performance.now();
        function tick(now) {
            const elapsed = now - startTs;
            bands.forEach((el, i)=>{
                const s = i * STAGGER;
                let tx = elapsed < s ? 0 : elapsed < s + ENTER_DUR ? easeOutExpo((elapsed - s) / ENTER_DUR) * (W + 4) : W + 4;
                el.style.transform = `translateX(${tx}px)`;
            });
            if (!called && elapsed >= COVERED_AT) {
                called = true;
                rafId = null;
                if (typeof onCovered === "function") onCovered();
                return;
            }
            rafId = requestAnimationFrame(tick);
        }
        rafId = requestAnimationFrame(tick);
    }
    // Bands start covered → sweep OUT
    function exit(onDone) {
        buildBands(true);
        container.classList.add("active");
        document.documentElement.classList.remove("pt-loading");
        const W = window.innerWidth;
        const TOTAL = EXIT_DUR + (N_BANDS - 1) * STAGGER;
        const startTs = performance.now();
        function tick(now) {
            const elapsed = now - startTs;
            bands.forEach((el, i)=>{
                const s = i * STAGGER;
                let tx = elapsed < s ? W + 4 : elapsed < s + EXIT_DUR ? W + 4 + easeInExpo((elapsed - s) / EXIT_DUR) * (W + 4) : (W + 4) * 2;
                el.style.transform = `translateX(${tx}px)`;
            });
            if (elapsed < TOTAL) rafId = requestAnimationFrame(tick);
            else {
                container.classList.remove("active");
                bands.forEach((el)=>el.remove());
                bands = [];
                rafId = null;
                if (typeof onDone === "function") onDone();
            }
        }
        rafId = requestAnimationFrame(tick);
    }
    return {
        enter: enter,
        exit: exit
    };
})();
// Wire up all internal links
document.querySelectorAll("a[href]").forEach((link)=>{
    const href = link.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("http") || href.startsWith("mailto:") || link.hasAttribute("download") || link.getAttribute("target") === "_blank") return;
    link.addEventListener("click", (e)=>{
        e.preventDefault();
        sessionStorage.setItem("pt-active", "1");
        $54b47fc030b7b21e$var$PageTransition.enter(()=>{
            window.location.href = href;
        });
    });
});
// ── Letter animation ──────────────────────────────────────────
const $54b47fc030b7b21e$var$letterFlash = document.getElementById("letter-anim-flash");
function $54b47fc030b7b21e$var$animateLetters(el, { delay: delay = 80, flashDur: flashDur = 120, squareH: squareH = 0.82, squareV: squareV = 0.08 } = {}) {
    // Collect nodes before clearing — preserve <br> elements
    const nodes = Array.from(el.childNodes);
    el.innerHTML = "";
    el.style.display = "flex";
    el.style.flexWrap = "wrap";
    el.style.alignItems = "baseline";
    nodes.forEach((node)=>{
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR") {
            // Preserve line breaks as block-level flex breaks
            const br = document.createElement("span");
            br.style.cssText = "width:100%;height:0;display:block;";
            el.appendChild(br);
        } else {
            const text = node.textContent;
            text.split("").forEach((ch)=>{
                const span = document.createElement("span");
                span.className = "letter-anim-char";
                span.textContent = ch === " " ? "\xa0" : ch;
                el.appendChild(span);
            });
        }
    });
    const letters = Array.from(el.querySelectorAll(".letter-anim-char"));
    let flashTimer = null;
    requestAnimationFrame(()=>{
        const widths = letters.map((l)=>l.getBoundingClientRect().width).filter((w)=>w > 4);
        const avgW = widths.length ? Math.round(widths.reduce((a, b)=>a + b, 0) / widths.length) : 40;
        let i = 0;
        function showFlash(letterEl) {
            const rect = letterEl.getBoundingClientRect();
            const h = Math.round(rect.height * squareH);
            const w = avgW;
            const x = rect.left + (rect.width - w) / 2;
            const y = rect.top + rect.height * squareV;
            $54b47fc030b7b21e$var$letterFlash.style.cssText = `width:${w}px;height:${h}px;left:${x}px;top:${y}px;`;
            $54b47fc030b7b21e$var$letterFlash.classList.add("on");
            if (flashTimer) clearTimeout(flashTimer);
            flashTimer = setTimeout(()=>$54b47fc030b7b21e$var$letterFlash.classList.remove("on"), flashDur);
        }
        function step() {
            if (i >= letters.length) return;
            const cur = letters[i];
            cur.classList.add("visible");
            requestAnimationFrame(()=>showFlash(cur));
            i++;
            setTimeout(step, delay);
        }
        setTimeout(step, 200);
    });
}
// Exposé globalement pour home-about.js (classic script)
window.animateLetters = $54b47fc030b7b21e$var$animateLetters;
// ── Reveal animation (gallery images) ────────────────────────
let $54b47fc030b7b21e$var$revealReady = false;
const $54b47fc030b7b21e$var$revealPending = [];
const $54b47fc030b7b21e$var$revealObserver = new IntersectionObserver((entries)=>{
    if (!$54b47fc030b7b21e$var$revealReady) {
        entries.filter((e)=>e.isIntersecting).forEach((e)=>$54b47fc030b7b21e$var$revealPending.push(e.target));
        return;
    }
    const visible = entries.filter((e)=>e.isIntersecting);
    visible.sort((a, b)=>a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left).forEach((entry, i)=>{
        entry.target.style.setProperty("--reveal-delay", i * 110 + "ms");
        entry.target.classList.add("visible");
        $54b47fc030b7b21e$var$revealObserver.unobserve(entry.target);
    });
}, {
    threshold: 0.1
});
function $54b47fc030b7b21e$var$startReveal() {
    $54b47fc030b7b21e$var$revealReady = true;
    // Flush elements that were already intersecting during the PT
    if ($54b47fc030b7b21e$var$revealPending.length) {
        $54b47fc030b7b21e$var$revealPending.sort((a, b)=>a.getBoundingClientRect().top - b.getBoundingClientRect().top).forEach((el, i)=>{
            el.style.setProperty("--reveal-delay", i * 110 + "ms");
            el.classList.add("visible");
            $54b47fc030b7b21e$var$revealObserver.unobserve(el);
        });
        $54b47fc030b7b21e$var$revealPending.length = 0;
    }
}
// Déclenchement PT — ici startReveal est déjà définie
const $54b47fc030b7b21e$var$_ptWasActive = !!sessionStorage.getItem("pt-active");
const $54b47fc030b7b21e$var$_openProject = sessionStorage.getItem("open-project");
if ($54b47fc030b7b21e$var$_openProject) sessionStorage.removeItem("open-project");
if ($54b47fc030b7b21e$var$_ptWasActive) {
    sessionStorage.removeItem("pt-active");
    requestAnimationFrame(()=>$54b47fc030b7b21e$var$PageTransition.exit(()=>{
            $54b47fc030b7b21e$var$startReveal();
            if ($54b47fc030b7b21e$var$_openProject) setTimeout(()=>{
                const mediaItem = $54b47fc030b7b21e$var$MEDIA.find((m)=>m.name === $54b47fc030b7b21e$var$_openProject);
                if (mediaItem) $54b47fc030b7b21e$var$openProjectPanel(mediaItem);
            }, 400);
        }));
} else {
    $54b47fc030b7b21e$var$startReveal();
    if ($54b47fc030b7b21e$var$_openProject) setTimeout(()=>{
        const mediaItem = $54b47fc030b7b21e$var$MEDIA.find((m)=>m.name === $54b47fc030b7b21e$var$_openProject);
        if (mediaItem) $54b47fc030b7b21e$var$openProjectPanel(mediaItem);
    }, 400);
}
let $54b47fc030b7b21e$var$revealCount = 0;
// ── IntersectionObserver : lecture vidéo seulement quand visible ──
const $54b47fc030b7b21e$var$videoPlayObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        const v = entry.target;
        if (entry.isIntersecting) {
            if (v.paused) v.play().catch(()=>{});
        } else if (!v.paused) v.pause();
    });
}, {
    threshold: 0.1
});
function $54b47fc030b7b21e$var$makeMediaEl({ src: src, type: type }) {
    let el;
    if (type === "video") {
        el = document.createElement("video");
        el.preload = "none"; // ← ne charge rien tant que non visible
        el.src = src;
        el.muted = true;
        el.loop = true;
        el.playsInline = true;
        $54b47fc030b7b21e$var$videoPlayObserver.observe(el);
    } else {
        el = document.createElement("img");
        el.loading = "lazy"; // ← charge seulement quand l'image approche du viewport
        el.src = src;
    }
    const i = $54b47fc030b7b21e$var$revealCount++;
    const sign = i % 2 === 0 ? -1 : 1;
    el.style.setProperty("--rot-start", sign * (2 + i % 3) + "deg");
    el.classList.add("reveal");
    $54b47fc030b7b21e$var$revealObserver.observe(el);
    return el;
}
// ── Nav animations ────────────────────────────────────────────
document.querySelectorAll(".masthead .nav a:not(.nav__logo)").forEach((el)=>{
    el.addEventListener("mouseenter", ()=>$54b47fc030b7b21e$var$animateLetters(el, {
            delay: 35
        }));
});
const $54b47fc030b7b21e$var$filterToggle = document.getElementById("filter-toggle");
const $54b47fc030b7b21e$var$filterMenu = document.getElementById("filters");
if ($54b47fc030b7b21e$var$filterToggle) {
    $54b47fc030b7b21e$var$filterToggle.addEventListener("click", (e)=>{
        e.stopPropagation();
        $54b47fc030b7b21e$var$filterMenu.classList.toggle("open");
        if ($54b47fc030b7b21e$var$filterMenu.classList.contains("open")) document.querySelectorAll(".filter-tag").forEach((el, i)=>{
            setTimeout(()=>$54b47fc030b7b21e$var$animateLetters(el, {
                    delay: 28
                }), i * 60);
        });
    });
    document.addEventListener("click", (e)=>{
        if (!$54b47fc030b7b21e$var$filterMenu.contains(e.target) && e.target !== $54b47fc030b7b21e$var$filterToggle) $54b47fc030b7b21e$var$filterMenu.classList.remove("open");
    });
}
// ── Titre gallery hover ───────────────────────────────────────
const $54b47fc030b7b21e$var$galleryTitleEl = document.querySelector(".gallery-title");
if ($54b47fc030b7b21e$var$galleryTitleEl) {
    let titleCooldown = false;
    $54b47fc030b7b21e$var$galleryTitleEl.addEventListener("mouseenter", ()=>{
        if (titleCooldown) return;
        titleCooldown = true;
        $54b47fc030b7b21e$var$animateLetters($54b47fc030b7b21e$var$galleryTitleEl, {
            delay: 55,
            squareH: 0.75
        });
        setTimeout(()=>{
            titleCooldown = false;
        }, 4000);
    });
}
// ── Panel global ──────────────────────────────────────────────
const $54b47fc030b7b21e$var$panelBackdrop = document.getElementById("panel-backdrop");
const $54b47fc030b7b21e$var$projectPanel = document.getElementById("project-panel");
const $54b47fc030b7b21e$var$panelClose = document.getElementById("panel-close");
// ── Slider ────────────────────────────────────────────────────
let $54b47fc030b7b21e$var$sliderSlides = [];
let $54b47fc030b7b21e$var$sliderIdx = 0;
const $54b47fc030b7b21e$var$sliderTrack = document.getElementById("slider-track");
const $54b47fc030b7b21e$var$sliderDotsEl = document.getElementById("slider-dots");
const $54b47fc030b7b21e$var$sliderPrev = document.getElementById("slider-prev");
const $54b47fc030b7b21e$var$sliderNext = document.getElementById("slider-next");
function $54b47fc030b7b21e$var$renderSlider() {
    $54b47fc030b7b21e$var$sliderTrack.innerHTML = "";
    $54b47fc030b7b21e$var$sliderDotsEl.innerHTML = "";
    $54b47fc030b7b21e$var$sliderSlides.forEach((slide, i)=>{
        const div = document.createElement("div");
        div.className = "pp__slide";
        if (slide.type === "placeholder") {
            const ph = document.createElement("div");
            ph.className = "pp__slide-placeholder";
            div.appendChild(ph);
        } else {
            const media = slide.type === "video" ? Object.assign(document.createElement("video"), {
                src: slide.src,
                autoplay: true,
                muted: true,
                loop: true,
                playsInline: true
            }) : Object.assign(document.createElement("img"), {
                src: slide.src,
                alt: ""
            });
            media.className = "pp__slide-media";
            media.addEventListener("click", ()=>$54b47fc030b7b21e$var$openLightbox(slide.src, slide.type, $54b47fc030b7b21e$var$sliderSlides.filter((s)=>s.type !== "placeholder")));
            div.appendChild(media);
            if (slide.caption) {
                const cap = document.createElement("p");
                cap.className = "pp__slide-caption";
                cap.textContent = slide.caption;
                div.appendChild(cap);
            }
        }
        $54b47fc030b7b21e$var$sliderTrack.appendChild(div);
        const dot = document.createElement("button");
        dot.className = "pp__slider-dot" + (i === $54b47fc030b7b21e$var$sliderIdx ? " active" : "");
        dot.addEventListener("click", ()=>$54b47fc030b7b21e$var$goToSlide(i));
        $54b47fc030b7b21e$var$sliderDotsEl.appendChild(dot);
    });
    $54b47fc030b7b21e$var$updateSliderPosition();
}
// ── Lightbox slider ───────────────────────────────────────────
const $54b47fc030b7b21e$var$lightbox = document.createElement("div");
$54b47fc030b7b21e$var$lightbox.className = "pp-lightbox";
const $54b47fc030b7b21e$var$lbPrev = document.createElement("button");
$54b47fc030b7b21e$var$lbPrev.className = "pp-lightbox__nav pp-lightbox__nav--prev";
$54b47fc030b7b21e$var$lbPrev.innerHTML = "&#8592;";
$54b47fc030b7b21e$var$lbPrev.setAttribute("aria-label", "Pr\xe9c\xe9dent");
const $54b47fc030b7b21e$var$lbNext = document.createElement("button");
$54b47fc030b7b21e$var$lbNext.className = "pp-lightbox__nav pp-lightbox__nav--next";
$54b47fc030b7b21e$var$lbNext.innerHTML = "&#8594;";
$54b47fc030b7b21e$var$lbNext.setAttribute("aria-label", "Suivant");
const $54b47fc030b7b21e$var$lbClose = document.createElement("button");
$54b47fc030b7b21e$var$lbClose.className = "pp-lightbox__close";
$54b47fc030b7b21e$var$lbClose.innerHTML = "&#215;";
$54b47fc030b7b21e$var$lbClose.setAttribute("aria-label", "Fermer");
const $54b47fc030b7b21e$var$lbCounter = document.createElement("span");
$54b47fc030b7b21e$var$lbCounter.className = "pp-lightbox__counter";
const $54b47fc030b7b21e$var$lbMediaWrap = document.createElement("div");
$54b47fc030b7b21e$var$lbMediaWrap.className = "pp-lightbox__wrap";
$54b47fc030b7b21e$var$lightbox.appendChild($54b47fc030b7b21e$var$lbPrev);
$54b47fc030b7b21e$var$lightbox.appendChild($54b47fc030b7b21e$var$lbMediaWrap);
$54b47fc030b7b21e$var$lightbox.appendChild($54b47fc030b7b21e$var$lbNext);
$54b47fc030b7b21e$var$lightbox.appendChild($54b47fc030b7b21e$var$lbClose);
$54b47fc030b7b21e$var$lightbox.appendChild($54b47fc030b7b21e$var$lbCounter);
document.body.appendChild($54b47fc030b7b21e$var$lightbox);
let $54b47fc030b7b21e$var$lbSlides = [];
let $54b47fc030b7b21e$var$lbIndex = 0;
function $54b47fc030b7b21e$var$lbShowSlide(idx) {
    $54b47fc030b7b21e$var$lbIndex = (idx + $54b47fc030b7b21e$var$lbSlides.length) % $54b47fc030b7b21e$var$lbSlides.length;
    const slide = $54b47fc030b7b21e$var$lbSlides[$54b47fc030b7b21e$var$lbIndex];
    $54b47fc030b7b21e$var$lbMediaWrap.innerHTML = "";
    let el;
    if (slide.type === "video") el = Object.assign(document.createElement("video"), {
        src: slide.src,
        autoplay: true,
        muted: true,
        loop: true,
        playsInline: true
    });
    else el = Object.assign(document.createElement("img"), {
        src: slide.src,
        alt: ""
    });
    el.className = "pp-lightbox__media";
    el.addEventListener("click", (e)=>e.stopPropagation());
    $54b47fc030b7b21e$var$lbMediaWrap.appendChild(el);
    $54b47fc030b7b21e$var$lbCounter.textContent = `${$54b47fc030b7b21e$var$lbIndex + 1} / ${$54b47fc030b7b21e$var$lbSlides.length}`;
    $54b47fc030b7b21e$var$lbPrev.style.display = $54b47fc030b7b21e$var$lbSlides.length <= 1 ? "none" : "";
    $54b47fc030b7b21e$var$lbNext.style.display = $54b47fc030b7b21e$var$lbSlides.length <= 1 ? "none" : "";
}
function $54b47fc030b7b21e$var$openLightbox(src, type, slides) {
    $54b47fc030b7b21e$var$lbSlides = slides || [
        {
            src: src,
            type: type
        }
    ];
    const startIdx = $54b47fc030b7b21e$var$lbSlides.findIndex((s)=>s.src === src);
    $54b47fc030b7b21e$var$lightbox.classList.add("open");
    $54b47fc030b7b21e$var$lbShowSlide(startIdx >= 0 ? startIdx : 0);
    document.addEventListener("keydown", $54b47fc030b7b21e$var$lbKeyHandler);
}
function $54b47fc030b7b21e$var$closeLightbox() {
    $54b47fc030b7b21e$var$lightbox.classList.remove("open");
    document.removeEventListener("keydown", $54b47fc030b7b21e$var$lbKeyHandler);
    $54b47fc030b7b21e$var$lbMediaWrap.innerHTML = "";
}
function $54b47fc030b7b21e$var$lbKeyHandler(e) {
    if (e.key === "Escape") $54b47fc030b7b21e$var$closeLightbox();
    if (e.key === "ArrowRight") $54b47fc030b7b21e$var$lbShowSlide($54b47fc030b7b21e$var$lbIndex + 1);
    if (e.key === "ArrowLeft") $54b47fc030b7b21e$var$lbShowSlide($54b47fc030b7b21e$var$lbIndex - 1);
}
$54b47fc030b7b21e$var$lbPrev.addEventListener("click", (e)=>{
    e.stopPropagation();
    $54b47fc030b7b21e$var$lbShowSlide($54b47fc030b7b21e$var$lbIndex - 1);
});
$54b47fc030b7b21e$var$lbNext.addEventListener("click", (e)=>{
    e.stopPropagation();
    $54b47fc030b7b21e$var$lbShowSlide($54b47fc030b7b21e$var$lbIndex + 1);
});
$54b47fc030b7b21e$var$lbClose.addEventListener("click", (e)=>{
    e.stopPropagation();
    $54b47fc030b7b21e$var$closeLightbox();
});
$54b47fc030b7b21e$var$lightbox.addEventListener("click", $54b47fc030b7b21e$var$closeLightbox);
// Swipe mobile
let $54b47fc030b7b21e$var$lbTouchX = null;
$54b47fc030b7b21e$var$lightbox.addEventListener("touchstart", (e)=>{
    $54b47fc030b7b21e$var$lbTouchX = e.touches[0].clientX;
}, {
    passive: true
});
$54b47fc030b7b21e$var$lightbox.addEventListener("touchend", (e)=>{
    if ($54b47fc030b7b21e$var$lbTouchX === null) return;
    const dx = e.changedTouches[0].clientX - $54b47fc030b7b21e$var$lbTouchX;
    if (Math.abs(dx) > 50) dx < 0 ? $54b47fc030b7b21e$var$lbShowSlide($54b47fc030b7b21e$var$lbIndex + 1) : $54b47fc030b7b21e$var$lbShowSlide($54b47fc030b7b21e$var$lbIndex - 1);
    $54b47fc030b7b21e$var$lbTouchX = null;
});
function $54b47fc030b7b21e$var$updateSliderPosition() {
    const slide = $54b47fc030b7b21e$var$sliderTrack.querySelectorAll(".pp__slide")[$54b47fc030b7b21e$var$sliderIdx];
    if (slide) $54b47fc030b7b21e$var$sliderTrack.scrollTo({
        left: slide.offsetLeft - $54b47fc030b7b21e$var$sliderTrack.offsetLeft,
        behavior: "smooth"
    });
    document.querySelectorAll(".pp__slider-dot").forEach((dot, i)=>{
        dot.classList.toggle("active", i === $54b47fc030b7b21e$var$sliderIdx);
    });
    $54b47fc030b7b21e$var$sliderPrev.disabled = $54b47fc030b7b21e$var$sliderIdx === 0;
    $54b47fc030b7b21e$var$sliderNext.disabled = $54b47fc030b7b21e$var$sliderIdx === $54b47fc030b7b21e$var$sliderSlides.length - 1;
}
function $54b47fc030b7b21e$var$goToSlide(idx) {
    $54b47fc030b7b21e$var$sliderIdx = Math.max(0, Math.min(idx, $54b47fc030b7b21e$var$sliderSlides.length - 1));
    $54b47fc030b7b21e$var$updateSliderPosition();
}
$54b47fc030b7b21e$var$sliderPrev.addEventListener("click", ()=>$54b47fc030b7b21e$var$goToSlide($54b47fc030b7b21e$var$sliderIdx - 1));
$54b47fc030b7b21e$var$sliderNext.addEventListener("click", ()=>$54b47fc030b7b21e$var$goToSlide($54b47fc030b7b21e$var$sliderIdx + 1));
function $54b47fc030b7b21e$var$openProjectPanel(mediaItem) {
    document.getElementById("panel-cat-label").textContent = mediaItem.category;
    const titleEl = document.getElementById("panel-title");
    titleEl.textContent = mediaItem.name;
    document.getElementById("panel-cat-val").textContent = mediaItem.category;
    document.getElementById("panel-year").textContent = mediaItem.year || "\u2014";
    const skillsEl = document.getElementById("panel-skills");
    skillsEl.innerHTML = "";
    (mediaItem.skills || []).forEach((s)=>{
        const pill = document.createElement("span");
        pill.className = "pp-skill";
        pill.textContent = s;
        skillsEl.appendChild(pill);
    });
    // Description : use EN version if lang=en and available
    const project = $54b47fc030b7b21e$var$PROJECTS.find((p)=>p.name === mediaItem.name);
    window.__openedProject = project || null;
    const desc = (0, $dA2FI.getLang)() === "en" && project && (0, $dA2FI.PROJECT_DESC_EN)[project.name] ? (0, $dA2FI.PROJECT_DESC_EN)[project.name] : mediaItem.description || mediaItem.presentation || (0, $dA2FI.t)("panel.fallback");
    document.getElementById("panel-description").textContent = desc;
    // Galerie : utilise les vrais médias du projet si disponibles
    if (project && project.gallery && project.gallery.length) $54b47fc030b7b21e$var$sliderSlides = project.gallery.map((g)=>({
            src: g.src,
            type: g.type,
            caption: ""
        }));
    else $54b47fc030b7b21e$var$sliderSlides = [
        {
            src: mediaItem.src,
            type: mediaItem.type,
            caption: ""
        }
    ];
    $54b47fc030b7b21e$var$sliderIdx = 0;
    $54b47fc030b7b21e$var$renderSlider();
    // Liens
    const textsEl = $54b47fc030b7b21e$var$projectPanel.querySelector(".pp__texts");
    const existingLinks = $54b47fc030b7b21e$var$projectPanel.querySelector(".pp__links");
    if (existingLinks) existingLinks.remove();
    if (project && project.links && project.links.length) {
        const linksDiv = document.createElement("div");
        linksDiv.className = "pp__links";
        project.links.forEach((link)=>{
            const a = document.createElement("a");
            a.href = link.url;
            a.target = "_blank";
            a.rel = "noopener";
            a.className = "pp__link";
            // Translate the link label
            const labelMap = {
                "Voir le site": "link.website",
                "Voir sur Figma": "link.figma",
                "Voir sur YouTube": "link.youtube",
                "GitHub": "link.github"
            };
            a.textContent = (labelMap[link.label] ? (0, $dA2FI.t)(labelMap[link.label]) : link.label) + " \u2197";
            linksDiv.appendChild(a);
        });
        textsEl.appendChild(linksDiv);
    }
    $54b47fc030b7b21e$var$projectPanel.querySelector(".pp__scroll").scrollTop = 0;
    $54b47fc030b7b21e$var$panelBackdrop.classList.add("open");
    $54b47fc030b7b21e$var$projectPanel.classList.add("open");
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    $54b47fc030b7b21e$var$panelClose.focus();
    setTimeout(()=>{
        $54b47fc030b7b21e$var$animateLetters(titleEl, {
            delay: 55
        });
        $54b47fc030b7b21e$var$projectPanel.querySelectorAll(".pp__label").forEach((el, i)=>{
            setTimeout(()=>$54b47fc030b7b21e$var$animateLetters(el, {
                    delay: 25
                }), 100 + i * 70);
        });
    }, 200);
}
let $54b47fc030b7b21e$var$currentOpenClose = null;
function $54b47fc030b7b21e$var$closeProjectPanel() {
    $54b47fc030b7b21e$var$panelBackdrop.classList.remove("open");
    $54b47fc030b7b21e$var$projectPanel.classList.remove("open");
    $54b47fc030b7b21e$var$projectPanel.classList.remove("expanded");
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
    if ($54b47fc030b7b21e$var$currentOpenClose) $54b47fc030b7b21e$var$currentOpenClose = null;
}
// ── Expansion 100% au scroll ───────────────────────────────────
const $54b47fc030b7b21e$var$ppScroll = $54b47fc030b7b21e$var$projectPanel.querySelector(".pp__scroll");
$54b47fc030b7b21e$var$ppScroll.addEventListener("scroll", ()=>{
    if ($54b47fc030b7b21e$var$ppScroll.scrollTop > 40) $54b47fc030b7b21e$var$projectPanel.classList.add("expanded");
    else $54b47fc030b7b21e$var$projectPanel.classList.remove("expanded");
}, {
    passive: true
});
$54b47fc030b7b21e$var$panelClose.addEventListener("click", $54b47fc030b7b21e$var$closeProjectPanel);
$54b47fc030b7b21e$var$panelBackdrop.addEventListener("click", $54b47fc030b7b21e$var$closeProjectPanel);
document.addEventListener("keydown", (e)=>{
    if (e.key === "Escape" && $54b47fc030b7b21e$var$projectPanel.classList.contains("open")) $54b47fc030b7b21e$var$closeProjectPanel();
});
// ── Swipe vers le bas pour fermer le panel (mobile) ───────────
(function() {
    const ppBar = $54b47fc030b7b21e$var$projectPanel.querySelector(".pp__bar");
    if (!ppBar) return;
    let touchStartY = 0;
    let dragging = false;
    ppBar.addEventListener("touchstart", (e)=>{
        touchStartY = e.touches[0].clientY;
        dragging = false;
    }, {
        passive: true
    });
    ppBar.addEventListener("touchmove", (e)=>{
        const dy = e.touches[0].clientY - touchStartY;
        if (dy > 0) {
            if (!dragging) {
                dragging = true;
                $54b47fc030b7b21e$var$projectPanel.style.transition = "none";
            }
            const clamped = Math.min(dy, 320);
            $54b47fc030b7b21e$var$projectPanel.style.transform = `translateY(${clamped * 0.6}px)`;
            $54b47fc030b7b21e$var$projectPanel.style.opacity = `${1 - clamped / 320 * 0.5}`;
        }
    }, {
        passive: true
    });
    ppBar.addEventListener("touchend", (e)=>{
        const dy = e.changedTouches[0].clientY - touchStartY;
        $54b47fc030b7b21e$var$projectPanel.style.transition = "";
        $54b47fc030b7b21e$var$projectPanel.style.transform = "";
        $54b47fc030b7b21e$var$projectPanel.style.opacity = "";
        if (dragging && dy > 80) {
            if ($54b47fc030b7b21e$var$currentOpenClose) $54b47fc030b7b21e$var$currentOpenClose();
            else $54b47fc030b7b21e$var$closeProjectPanel();
        }
        dragging = false;
    }, {
        passive: true
    });
})();
// ── Galerie ───────────────────────────────────────────────────
const $54b47fc030b7b21e$var$gallery = document.getElementById("gallery");
if ($54b47fc030b7b21e$var$gallery) {
    const GAP_PATTERN = [
        3,
        2,
        3,
        2,
        3,
        2
    ];
    let gapPatternIdx = 0;
    function getGap() {
        return GAP_PATTERN[gapPatternIdx++ % GAP_PATTERN.length];
    }
    function getCols() {
        return window.innerWidth <= 768 ? 3 : 6;
    }
    let COLS = getCols();
    let bottomRow = null;
    let cellCount = 0;
    let mediaIdx = 0;
    let nextMediaAt = 0;
    let gapEnd = 0;
    let currentFullGroup = null;
    let currentBorderGroup = null;
    let currentProjectHoverMedia = [];
    let currentProjectHoverIdx = 0;
    // Média actifs (tous par défaut, filtrés sur demande)
    let activeMedia = $54b47fc030b7b21e$var$MEDIA;
    let activeProjects = $54b47fc030b7b21e$var$PROJECTS;
    function makeCell() {
        const cell = document.createElement("div");
        cell.className = "cell";
        const c1 = document.createElement("div");
        c1.className = "cross";
        c1.style.cssText = "top:0; left:0;";
        cell.appendChild(c1);
        const isMedia = mediaIdx < activeMedia.length && cellCount === nextMediaAt;
        const isGap = !isMedia && currentBorderGroup !== null && cellCount < gapEnd;
        const isHover = isGap && currentProjectHoverIdx < currentProjectHoverMedia.length;
        if (isMedia) {
            cell.classList.add("cell--media");
            cell.dataset.category = activeMedia[mediaIdx].category;
            cell.appendChild($54b47fc030b7b21e$var$makeMediaEl(activeMedia[mediaIdx]));
            const fullGroup = [
                cell
            ];
            cell._groupCells = fullGroup;
            const borderGroup = [];
            currentFullGroup = fullGroup;
            currentBorderGroup = borderGroup;
            // Hover images = uniquement celles de ce projet
            const proj = $54b47fc030b7b21e$var$PROJECTS.find((p)=>p.name === activeMedia[mediaIdx].name);
            currentProjectHoverMedia = proj ? proj.hoverMedia !== undefined ? proj.hoverMedia : proj.gallery : [];
            currentProjectHoverIdx = 0;
            const gap = getGap();
            gapEnd = cellCount + 1 + gap;
            nextMediaAt = gapEnd;
            const mediaItem = activeMedia[mediaIdx];
            const itemName = mediaItem.name;
            let rect = null;
            cell.addEventListener("click", ()=>{
                if ($54b47fc030b7b21e$var$currentOpenClose) {
                    $54b47fc030b7b21e$var$currentOpenClose();
                    $54b47fc030b7b21e$var$currentOpenClose = null;
                }
                $54b47fc030b7b21e$var$openProjectPanel(mediaItem);
                cell._groupCells.forEach((c)=>c.classList.add("is-selected"));
                $54b47fc030b7b21e$var$currentOpenClose = ()=>{
                    $54b47fc030b7b21e$var$closeProjectPanel();
                    cell._groupCells.forEach((c)=>c.classList.remove("is-selected"));
                };
            });
            const showRect = ()=>{
                if (rect) return;
                cell.classList.add("is-source");
                if (borderGroup.length > 0) {
                    const galleryRect = $54b47fc030b7b21e$var$gallery.getBoundingClientRect();
                    const allCells = [
                        cell,
                        ...borderGroup
                    ];
                    const rows = new Map();
                    allCells.forEach((c)=>{
                        const r = c.getBoundingClientRect();
                        const rowKey = Math.round(r.top);
                        if (!rows.has(rowKey)) rows.set(rowKey, []);
                        rows.get(rowKey).push(r);
                    });
                    const rects = [];
                    rows.forEach((cellRects)=>{
                        const minX = Math.min(...cellRects.map((r)=>r.left));
                        const minY = Math.min(...cellRects.map((r)=>r.top));
                        const maxX = Math.max(...cellRects.map((r)=>r.right));
                        const maxY = Math.max(...cellRects.map((r)=>r.bottom));
                        const el = document.createElement("div");
                        el.className = "gap-rect";
                        el.style.cssText = `left:${minX - galleryRect.left}px;top:${minY - galleryRect.top}px;width:${maxX - minX}px;height:${maxY - minY}px;`;
                        rects.push(el);
                        $54b47fc030b7b21e$var$gallery.appendChild(el);
                    });
                    $54b47fc030b7b21e$var$hoverLabel.textContent = itemName;
                    $54b47fc030b7b21e$var$hoverLabel.classList.add("is-visible");
                    rect = rects;
                }
            };
            const hideRect = ()=>{
                cell.classList.remove("is-source");
                $54b47fc030b7b21e$var$hoverLabel.classList.remove("is-visible");
                if (rect) {
                    const dying = rect;
                    rect = null;
                    dying.forEach((el)=>{
                        el.classList.add("is-out");
                        el.addEventListener("transitionend", ()=>el.remove(), {
                            once: true
                        });
                    });
                }
            };
            cell.addEventListener("mouseenter", showRect);
            cell.addEventListener("mouseleave", hideRect);
            mediaIdx++;
        } else if (isGap) {
            currentBorderGroup.push(cell);
            currentFullGroup.push(cell);
            const sourceCell = currentFullGroup[0];
            cell.addEventListener("mouseenter", ()=>sourceCell.dispatchEvent(new MouseEvent("mouseenter")));
            cell.addEventListener("mouseleave", ()=>sourceCell.dispatchEvent(new MouseEvent("mouseleave")));
            cell.addEventListener("click", ()=>sourceCell.dispatchEvent(new MouseEvent("click")));
            if (isHover) {
                cell.classList.add("cell--hover");
                cell.appendChild($54b47fc030b7b21e$var$makeMediaEl(currentProjectHoverMedia[currentProjectHoverIdx]));
                currentProjectHoverIdx++;
            } else cell.classList.add("cell--gap");
        }
        cellCount++;
        return cell;
    }
    function makeBottomRow() {
        const row = document.createElement("div");
        row.className = "row";
        row.style.height = "0";
        for(let c = 0; c < COLS; c++){
            const cell = document.createElement("div");
            cell.style.cssText = "position:relative; height:0; overflow:visible;";
            const cross = document.createElement("div");
            cross.className = "cross";
            cross.style.cssText = "top:0; left:0;";
            cell.appendChild(cross);
            if (c === COLS - 1) {
                const crossR = document.createElement("div");
                crossR.className = "cross";
                crossR.style.cssText = "top:0; right:0; left:auto; transform:translate(50%,-50%);";
                cell.appendChild(crossR);
            }
            row.appendChild(cell);
        }
        return row;
    }
    function addRows(count) {
        if (bottomRow) bottomRow.remove();
        for(let r = 0; r < count; r++){
            const row = document.createElement("div");
            row.className = "row";
            for(let c = 0; c < COLS; c++){
                const cell = makeCell();
                if (c === COLS - 1) {
                    const cr = document.createElement("div");
                    cr.className = "cross";
                    cr.style.cssText = "top:0; right:0; left:auto; transform:translate(50%,-50%);";
                    cell.appendChild(cr);
                }
                row.appendChild(cell);
            }
            $54b47fc030b7b21e$var$gallery.appendChild(row);
        }
        bottomRow = makeBottomRow();
        $54b47fc030b7b21e$var$gallery.appendChild(bottomRow);
    }
    // Calcul dynamique : juste assez de rangées pour tous les projets + leurs gaps
    const GAP_PATTERN_CALC = [
        3,
        2,
        3,
        2,
        3,
        2
    ];
    function resetGalleryState() {
        $54b47fc030b7b21e$var$gallery.innerHTML = "";
        bottomRow = null;
        cellCount = 0;
        mediaIdx = 0;
        nextMediaAt = 0;
        gapEnd = 0;
        currentFullGroup = null;
        currentBorderGroup = null;
        gapPatternIdx = 0;
        $54b47fc030b7b21e$var$revealCount = 0;
    }
    function rebuildGallery(cat) {
        activeMedia = cat === "all" ? $54b47fc030b7b21e$var$MEDIA : $54b47fc030b7b21e$var$MEDIA.filter((m)=>m.category === cat);
        activeProjects = cat === "all" ? $54b47fc030b7b21e$var$PROJECTS : $54b47fc030b7b21e$var$PROJECTS.filter((p)=>p.category === cat);
        resetGalleryState();
        const total = activeProjects.reduce((sum, _, i)=>sum + 1 + GAP_PATTERN_CALC[i % GAP_PATTERN_CALC.length], 0);
        addRows(Math.ceil(total / COLS));
    }
    const totalCells = $54b47fc030b7b21e$var$PROJECTS.reduce((sum, _, i)=>sum + 1 + GAP_PATTERN_CALC[i % GAP_PATTERN_CALC.length], 0);
    const rowsNeeded = Math.ceil(totalCells / COLS);
    addRows(rowsNeeded);
    // ── Compteur projets ────────────────────────────────────────
    const projectCountEl = document.getElementById("project-count");
    function updateCount(cat) {
        if (!projectCountEl) return;
        const total = cat === "all" ? $54b47fc030b7b21e$var$MEDIA.length : $54b47fc030b7b21e$var$MEDIA.filter((m)=>m.category === cat).length;
        projectCountEl.dataset.total = total;
        projectCountEl.textContent = `\u{2014} ${total} ${(0, $dA2FI.t)(total > 1 ? "pg.count.plural" : "pg.count.singular")}`;
    }
    updateCount("all");
    // ── Filtres ─────────────────────────────────────────────────
    const filterTags = document.querySelectorAll(".filter-tag");
    filterTags.forEach((btn)=>{
        btn.addEventListener("click", ()=>{
            filterTags.forEach((b)=>b.classList.remove("active"));
            btn.classList.add("active");
            const cat = btn.dataset.filter;
            rebuildGallery(cat);
            updateCount(cat);
        });
    });
    window.addEventListener("resize", ()=>{
        const newCols = getCols();
        if (newCols !== COLS) {
            COLS = newCols;
            resetGalleryState();
            const _totalCells = activeProjects.reduce((sum, _, i)=>sum + 1 + GAP_PATTERN_CALC[i % GAP_PATTERN_CALC.length], 0);
            addRows(Math.ceil(_totalCells / COLS));
        }
    });
}
// ── Barre de progression latérale ────────────────────────────
(function() {
    const fill = document.getElementById("nav-fill");
    const dot = document.getElementById("nav-dot");
    if (!fill || !dot) return;
    function update() {
        const p = Math.min(1, window.scrollY / (document.body.scrollHeight - window.innerHeight || 1));
        fill.style.height = p * 100 + "%";
        dot.style.top = p * 100 + "%";
    }
    window.addEventListener("scroll", update, {
        passive: true
    });
    update();
})();
// ── Animations chargement home ────────────────────────────────
const $54b47fc030b7b21e$var$brandTextEl = document.getElementById("brand-text");
if ($54b47fc030b7b21e$var$brandTextEl) setTimeout(()=>$54b47fc030b7b21e$var$animateLetters($54b47fc030b7b21e$var$brandTextEl, {
        delay: 45
    }), 100);
document.querySelectorAll(".masthead .nav a:not(.nav__logo)").forEach((el, i)=>{
    setTimeout(()=>$54b47fc030b7b21e$var$animateLetters(el, {
            delay: 35
        }), 200 + i * 120);
});
document.querySelectorAll(".hero-line").forEach((el, i)=>{
    setTimeout(()=>$54b47fc030b7b21e$var$animateLetters(el, {
            delay: 15
        }), 400 + i * 200);
});
const $54b47fc030b7b21e$var$taglineEl = document.querySelector(".home-hero__tagline");
if ($54b47fc030b7b21e$var$taglineEl) {
    $54b47fc030b7b21e$var$taglineEl.style.opacity = "0";
    $54b47fc030b7b21e$var$taglineEl.style.transform = "translateY(16px)";
    $54b47fc030b7b21e$var$taglineEl.style.transition = "opacity 1.1s cubic-bezier(0.22,1,0.36,1) 0.3s, transform 1.2s cubic-bezier(0.22,1,0.36,1) 0.3s";
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
            $54b47fc030b7b21e$var$taglineEl.style.opacity = "1";
            $54b47fc030b7b21e$var$taglineEl.style.transform = "translateY(0)";
        }));
}
// ── Hero ──────────────────────────────────────────────────────
const $54b47fc030b7b21e$var$masthead = document.querySelector(".masthead");
const $54b47fc030b7b21e$var$homeHeroEl = document.querySelector(".home-hero");
// ── (GSAP animations gérées dans home-gsap.js) ───────────────
function $54b47fc030b7b21e$var$animateTextByWords(selector = "[data-animate-text]", options = {}) {
    const { animateOnScroll: animateOnScroll = true, delay: delay = 0, duration: duration = 2, stagger: stagger = 0.03, scrollTriggerStart: scrollTriggerStart = "top 80%", scope: scope = document } = options;
    scope.querySelectorAll(selector).forEach((element)=>{
        if (element.hasAttribute("data-text-animated")) return;
        element.setAttribute("data-text-animated", "true");
        const wordSpans = element.textContent.split(/(\s+)/).map((word)=>{
            if (word.trim() === "") {
                element.appendChild(document.createTextNode(word));
                return null;
            }
            const wrapper = document.createElement("span");
            wrapper.style.cssText = "display:inline-block;overflow:hidden;vertical-align:bottom";
            const span = document.createElement("span");
            span.textContent = word;
            span.style.display = "inline-block";
            wrapper.appendChild(span);
            element.appendChild(wrapper);
            return span;
        }).filter(Boolean);
        gsap.set(wordSpans, {
            y: "100%"
        });
        const animProps = {
            y: "0%",
            duration: duration,
            stagger: stagger,
            ease: "power4.out",
            delay: delay
        };
        if (animateOnScroll) gsap.to(wordSpans, {
            ...animProps,
            scrollTrigger: {
                trigger: element,
                start: scrollTriggerStart,
                once: true
            }
        });
        else gsap.to(wordSpans, animProps);
    });
}
// ── Conversation slider (GSAP) ────────────────────────────────
function $54b47fc030b7b21e$var$initConversationSlider() {
    const container = document.querySelector(".container-conversation-slider");
    if (!container) return;
    const groups = [
        ...document.querySelectorAll(".copy-group")
    ];
    const NUM_GROUPS = groups.length;
    const GROUP_SEG = 1 / NUM_GROUPS;
    const STAGGER_RATIO = 0.2;
    const CROSSFADE_THRESHOLDS = [
        0.6,
        0.73,
        0.86
    ];
    const pendingDelays = new Map();
    function prepareWords(block) {
        const p = block.querySelector("p");
        if (!p || p.dataset.wordsReady) return;
        p.dataset.wordsReady = "true";
        const words = p.textContent.split(/(\s+)/);
        p.innerHTML = "";
        words.forEach((word)=>{
            if (word.trim() === "") {
                p.appendChild(document.createTextNode(word));
                return;
            }
            const wrapper = document.createElement("span");
            wrapper.style.cssText = "display:inline-block;overflow:hidden;vertical-align:bottom";
            const span = document.createElement("span");
            span.textContent = word;
            span.style.display = "inline-block";
            wrapper.appendChild(span);
            p.appendChild(wrapper);
        });
        gsap.set(p.querySelectorAll("span > span"), {
            y: "100%"
        });
    }
    function animateWords(block) {
        const spans = block.querySelectorAll("p span > span");
        if (!spans.length) return;
        gsap.killTweensOf(spans);
        gsap.fromTo(spans, {
            y: "100%"
        }, {
            y: "0%",
            duration: 1.2,
            stagger: 0.04,
            ease: "power4.out"
        });
    }
    function animateWordsOut(block) {
        const spans = block.querySelectorAll("p span > span");
        if (!spans.length) return;
        gsap.killTweensOf(spans);
        gsap.to(spans, {
            y: "100%",
            duration: 0.8,
            stagger: 0.03,
            ease: "power4.in"
        });
    }
    function killPendingDelay(block) {
        if (pendingDelays.has(block)) {
            pendingDelays.get(block).kill();
            pendingDelays.delete(block);
        }
    }
    function resetBlock(block) {
        killPendingDelay(block);
        const spans = block.querySelectorAll("p span > span");
        gsap.killTweensOf(spans);
        gsap.set(block, {
            autoAlpha: 0
        });
        gsap.set(spans, {
            y: "100%"
        });
    }
    const blockVisible = new WeakMap();
    const blockCrossed = new WeakMap();
    const igFaded = new WeakMap();
    const groupXFired = new Map();
    const imageGroupes = [
        ...document.querySelectorAll(".image-groupe")
    ];
    imageGroupes.forEach((ig, i)=>{
        if (i === 0) {
            gsap.set(ig, {
                autoAlpha: 1,
                display: "flex"
            });
            igFaded.set(ig, true);
        } else {
            gsap.set(ig, {
                autoAlpha: 0,
                display: "none"
            });
            igFaded.set(ig, false);
        }
    });
    groups.forEach((group)=>{
        group.querySelectorAll(".copy-block").forEach((block)=>{
            prepareWords(block);
            blockVisible.set(block, false);
            blockCrossed.set(block, false);
        });
        gsap.set(group.querySelectorAll(".copy-block"), {
            autoAlpha: 0
        });
        groupXFired.set(group, [
            false,
            false,
            false
        ]);
    });
    ScrollTrigger.create({
        trigger: container,
        start: "top top",
        end: "bottom bottom",
        onUpdate (self) {
            const p = self.progress;
            groups.forEach((group, g)=>{
                const groupStart = g * GROUP_SEG;
                const groupP = (p - groupStart) / GROUP_SEG;
                const blocks = [
                    ...group.querySelectorAll(".copy-block")
                ];
                const isFirst = g === 0;
                const isLast = g === NUM_GROUPS - 1;
                const isActive = (isFirst ? groupP >= 0 : groupP > 0) && (isLast ? true : groupP < 1);
                const exitP = !isLast && groupP > 0.6 ? (groupP - 0.6) / 0.4 : 0;
                const ig = imageGroupes[g];
                if (ig) {
                    if (!isActive) {
                        gsap.killTweensOf(ig);
                        gsap.set(ig, {
                            autoAlpha: 0,
                            display: "none"
                        });
                        igFaded.set(ig, false);
                    } else {
                        if (!igFaded.get(ig)) {
                            igFaded.set(ig, true);
                            gsap.set(ig, {
                                display: "flex",
                                autoAlpha: 1,
                                x: 0
                            });
                            const igChildren = ig.querySelectorAll(".ig-placeholder, img");
                            gsap.set(igChildren, {
                                autoAlpha: 0
                            });
                            gsap.to(igChildren, {
                                autoAlpha: 1,
                                duration: 1.5,
                                ease: "power2.out",
                                stagger: 0.4
                            });
                        }
                        gsap.set(ig, {
                            x: `${-exitP * 110}vw`
                        });
                    }
                }
                if (!isActive) {
                    blocks.forEach((block)=>{
                        resetBlock(block);
                        blockVisible.set(block, false);
                        blockCrossed.set(block, false);
                    });
                    groupXFired.set(group, [
                        false,
                        false,
                        false
                    ]);
                    return;
                }
                blocks.forEach((block, b)=>{
                    if (blockCrossed.get(block)) return;
                    const blockStart = b * STAGGER_RATIO;
                    const localP = (groupP - blockStart) / STAGGER_RATIO;
                    const blockOpacity = localP >= 1 ? 1 : localP > 0 ? localP : 0;
                    const wasVisible = blockVisible.get(block);
                    const isNowVisible = blockOpacity > 0;
                    if (!wasVisible && isNowVisible) {
                        killPendingDelay(block);
                        localP >= 1 ? gsap.set(block.querySelectorAll("p span > span"), {
                            y: "0%"
                        }) : animateWords(block);
                    } else if (wasVisible && !isNowVisible) gsap.set(block.querySelectorAll("p span > span"), {
                        y: "100%"
                    });
                    blockVisible.set(block, isNowVisible);
                    gsap.set(block, {
                        autoAlpha: blockOpacity
                    });
                });
                if (!isLast) {
                    const nextGroup = groups[g + 1];
                    const nextBlocks = [
                        ...nextGroup.querySelectorAll(".copy-block")
                    ];
                    const fired = groupXFired.get(group);
                    CROSSFADE_THRESHOLDS.forEach((threshold, b)=>{
                        if (groupP >= threshold && !fired[b]) {
                            fired[b] = true;
                            if (blocks[b]) animateWordsOut(blocks[b]);
                            if (nextBlocks[b]) {
                                killPendingDelay(nextBlocks[b]);
                                gsap.set(nextBlocks[b], {
                                    autoAlpha: 1
                                });
                                animateWords(nextBlocks[b]);
                                blockVisible.set(nextBlocks[b], true);
                                blockCrossed.set(nextBlocks[b], true);
                            }
                        } else if (groupP < threshold && fired[b]) {
                            fired[b] = false;
                            if (nextBlocks[b]) {
                                resetBlock(nextBlocks[b]);
                                blockVisible.set(nextBlocks[b], false);
                                blockCrossed.set(nextBlocks[b], false);
                            }
                            if (blocks[b]) gsap.set(blocks[b].querySelectorAll("p span > span"), {
                                y: "0%"
                            });
                        }
                    });
                }
            });
        }
    });
}
// ── Init GSAP animations ──────────────────────────────────────
if (document.querySelector(".container-conversation-slider")) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        $54b47fc030b7b21e$var$animateTextByWords("[data-animate-text]", {
            animateOnScroll: true,
            delay: 0.2,
            scrollTriggerStart: "top 95%"
        });
        $54b47fc030b7b21e$var$initConversationSlider();
    });
    else {
        $54b47fc030b7b21e$var$animateTextByWords("[data-animate-text]", {
            animateOnScroll: true,
            delay: 0.2,
            scrollTriggerStart: "top 95%"
        });
        $54b47fc030b7b21e$var$initConversationSlider();
    }
}
// ── Shared cross-grid builder ────────────────────────────────
function $54b47fc030b7b21e$var$buildCrossGrid(container, heightFn) {
    container.querySelectorAll(".cross").forEach((el)=>el.remove());
    const vw = window.innerWidth;
    const pad = Math.max(20, Math.min(vw * 0.04, 40));
    const cols = vw <= 768 ? 3 : 6;
    const cellW = (vw - pad * 2) / cols;
    const cellH = cellW * (3 / 4);
    const rows = Math.ceil(heightFn() / cellH) + 1;
    for(let r = 0; r <= rows; r++)for(let c = 0; c <= cols; c++){
        const cross = document.createElement("div");
        cross.className = "cross";
        cross.style.position = "absolute";
        cross.style.left = pad + c * cellW + "px";
        cross.style.top = r * cellH + "px";
        container.appendChild(cross);
    }
}
// ── Hero grid crosses ─────────────────────────────────────────
const $54b47fc030b7b21e$var$heroGrid = document.getElementById("hero-grid");
if ($54b47fc030b7b21e$var$heroGrid) {
    const build = ()=>$54b47fc030b7b21e$var$buildCrossGrid($54b47fc030b7b21e$var$heroGrid, ()=>$54b47fc030b7b21e$var$heroGrid.offsetHeight);
    build();
    window.addEventListener("resize", build);
}
// ── Hero video grid trail ─────────────────────────────────────
const $54b47fc030b7b21e$var$heroVideoWrap = document.getElementById("hero-video-wrap");
const $54b47fc030b7b21e$var$heroGridHoverEl = document.getElementById("hero-grid-hover");
if ($54b47fc030b7b21e$var$heroVideoWrap && $54b47fc030b7b21e$var$heroGridHoverEl) {
    const COLS = 72;
    const ROWS = 36;
    const TRAIL_LENGTH = 18;
    const TRAIL_COLOR = "255, 111, 58";
    const cellW = 100 / COLS;
    const cellH = 100 / ROWS;
    const trailCells = [];
    for(let r = 0; r < ROWS; r++)for(let c = 0; c < COLS; c++){
        const cell = document.createElement("div");
        cell.className = "cell";
        cell.style.left = `${c * cellW}%`;
        cell.style.top = `${r * cellH}%`;
        cell.style.width = `${cellW}%`;
        cell.style.height = `${cellH}%`;
        $54b47fc030b7b21e$var$heroGridHoverEl.appendChild(cell);
        trailCells.push(cell);
    }
    const cellTimers = new Map();
    const trail = [];
    function getTrailCell(col, row) {
        if (col < 0 || col >= COLS || row < 0 || row >= ROWS) return null;
        return trailCells[row * COLS + col];
    }
    function lightTrailCell(col, row, intensity) {
        const c = getTrailCell(col, row);
        if (!c) return;
        if (cellTimers.has(c)) clearTimeout(cellTimers.get(c));
        c.style.background = `rgba(${TRAIL_COLOR}, ${intensity})`;
        c.style.opacity = String(intensity);
        c.style.transform = `scale(${0.55 + intensity * 0.35})`;
        c.style.transition = "background 0.05s, transform 0.08s, opacity 0.05s";
        const timer = setTimeout(()=>{
            c.style.transition = "background 0.5s ease, transform 0.5s ease, opacity 0.5s ease";
            c.style.opacity = "0";
            c.style.transform = "scale(0.6)";
            cellTimers.delete(c);
        }, 80 + (1 - intensity) * 120);
        cellTimers.set(c, timer);
    }
    $54b47fc030b7b21e$var$heroVideoWrap.addEventListener("mousemove", function(e) {
        const rect = this.getBoundingClientRect();
        const localX = e.clientX - rect.left;
        const localY = e.clientY - rect.top;
        if (localX < 0 || localY < 0 || localX > rect.width || localY > rect.height) return;
        const col = Math.floor(localX / rect.width * COLS);
        const row = Math.floor(localY / rect.height * ROWS);
        if (col >= COLS || row >= ROWS) return;
        trail.push({
            col: col,
            row: row
        });
        if (trail.length > TRAIL_LENGTH) trail.shift();
        trail.forEach((pt, i)=>{
            const age = i / (trail.length - 1 || 1);
            const intensity = age * age * 0.85 + 0.05;
            lightTrailCell(pt.col, pt.row, intensity);
            if (age > 0.7) [
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ]
            ].forEach(([dc, dr])=>{
                if (Math.random() < 0.25 * age) lightTrailCell(pt.col + dc, pt.row + dr, intensity * 0.35);
            });
        });
    });
    $54b47fc030b7b21e$var$heroVideoWrap.addEventListener("mouseleave", ()=>{
        trail.length = 0;
    });
}
// ── Home grid section crosses ─────────────────────────────────
const $54b47fc030b7b21e$var$homeGridSection = document.getElementById("home-grid-section");
const $54b47fc030b7b21e$var$homeGridPin = document.getElementById("home-grid-pin");
const $54b47fc030b7b21e$var$homeExpandImg = document.getElementById("home-expand-img");
if ($54b47fc030b7b21e$var$homeGridSection && $54b47fc030b7b21e$var$homeGridPin) {
    const buildHome = ()=>$54b47fc030b7b21e$var$buildCrossGrid($54b47fc030b7b21e$var$homeGridPin, ()=>window.innerHeight);
    buildHome();
    window.addEventListener("resize", buildHome);
}
// ── Hero parallax ────────────────────────────────────────────
if ($54b47fc030b7b21e$var$heroVideoWrap) window.addEventListener("scroll", ()=>{
    if (window.scrollY > window.innerHeight) return;
    $54b47fc030b7b21e$var$heroVideoWrap.style.transform = `translateY(${window.scrollY * 0.28}px)`;
}, {
    passive: true
});
// ── Hero scroll hint ─────────────────────────────────────────
const $54b47fc030b7b21e$var$scrollHint = document.getElementById("scroll-hint");
if ($54b47fc030b7b21e$var$scrollHint) window.addEventListener("scroll", ()=>{
    if (window.scrollY > 40) $54b47fc030b7b21e$var$scrollHint.classList.add("hidden");
    else $54b47fc030b7b21e$var$scrollHint.classList.remove("hidden");
}, {
    passive: true
});
// ── Hover label ───────────────────────────────────────────────
const $54b47fc030b7b21e$var$hoverLabel = document.getElementById("hover-label");
if ($54b47fc030b7b21e$var$hoverLabel) {
    let bx = 0, by = 0, mx = 0, my = 0, rafId = null;
    document.addEventListener("mousemove", (e)=>{
        mx = e.clientX;
        my = e.clientY;
        if (!rafId) rafId = requestAnimationFrame(animateLabel);
    });
    function animateLabel() {
        bx += (mx - bx) * 0.1;
        by += (my - by) * 0.1;
        $54b47fc030b7b21e$var$hoverLabel.style.left = bx + "px";
        $54b47fc030b7b21e$var$hoverLabel.style.top = by + "px";
        rafId = requestAnimationFrame(animateLabel);
    }
}
// ── Initial loader ────────────────────────────────────────────
function $54b47fc030b7b21e$var$dismissLoader(beforeExit) {
    $54b47fc030b7b21e$var$PageTransition.enter(()=>{
        if (beforeExit) beforeExit();
        $54b47fc030b7b21e$var$initialLoader.style.display = "none";
        $54b47fc030b7b21e$var$PageTransition.exit($54b47fc030b7b21e$var$startReveal);
        document.documentElement.style.overflow = "";
        document.dispatchEvent(new CustomEvent("gsap-ready"));
    });
}
const $54b47fc030b7b21e$var$initialLoader = document.getElementById("initial-loader");
if ($54b47fc030b7b21e$var$initialLoader) {
    if ($54b47fc030b7b21e$var$_ptWasActive) $54b47fc030b7b21e$var$initialLoader.style.display = "none";
    else {
        document.documentElement.style.overflow = "hidden";
        // ── Pulse canvas ─────────────────────────────────────────
        const loaderCanvas = document.getElementById("loader-canvas");
        if (loaderCanvas) {
            const lCtx = loaderCanvas.getContext("2d");
            const LCOLS = 36, LROWS = 22, LGAP = 3;
            const LPULSE_SPEED = 0.018;
            const LTRAIL = 1.2;
            const LCOLOR = [
                49,
                49,
                49
            ];
            let lW, lH, lCW, lCH, lCX, lCY, lCells = [], lPulses = [], lRaf = null;
            function lResize() {
                lW = window.innerWidth;
                lH = window.innerHeight;
                loaderCanvas.width = Math.round(lW * devicePixelRatio);
                loaderCanvas.height = Math.round(lH * devicePixelRatio);
                lCtx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
                lCW = (lW - LGAP) / LCOLS;
                lCH = (lH - LGAP) / LROWS;
                lCX = lW / 2;
                lCY = lH / 2;
                lCells = [];
                for(let r = 0; r < LROWS; r++)for(let c = 0; c < LCOLS; c++){
                    const cx = c * lCW + lCW / 2 + LGAP / 2;
                    const cy = r * lCH + lCH / 2 + LGAP / 2;
                    lCells.push({
                        cx: cx,
                        cy: cy,
                        dist: Math.hypot(cx - lCX, cy - lCY)
                    });
                }
            }
            function lDraw() {
                lCtx.clearRect(0, 0, lW, lH);
                const maxDist = Math.hypot(lCX, lCY);
                const unit = Math.max(lCW, lCH);
                for (const cell of lCells){
                    let alpha = 0;
                    for (const p of lPulses){
                        const diff = p.r - cell.dist;
                        if (diff > 0 && diff < LTRAIL * unit) {
                            const t = diff / (LTRAIL * unit);
                            const a = Math.sin(t * Math.PI) * 0.82;
                            if (a > alpha) alpha = a;
                        }
                    }
                    if (alpha > 0.01) {
                        const size = (lCW - LGAP) * (0.36 + alpha * 0.28);
                        lCtx.globalAlpha = alpha;
                        lCtx.fillStyle = `rgb(${LCOLOR[0]},${LCOLOR[1]},${LCOLOR[2]})`;
                        lCtx.fillRect(cell.cx - size / 2, cell.cy - size / 2, size, size);
                    }
                }
                lCtx.globalAlpha = 1;
                const maxR = maxDist + unit * LTRAIL;
                lPulses = lPulses.filter((p)=>p.r < maxR);
                for (const p of lPulses)p.r += LPULSE_SPEED * maxDist;
                lRaf = requestAnimationFrame(lDraw);
            }
            lResize();
            lPulses.push({
                r: 0
            });
            const lInterval = setInterval(()=>lPulses.push({
                    r: 0
                }), 2200);
            lDraw();
            setTimeout(()=>{
                clearInterval(lInterval);
                $54b47fc030b7b21e$var$dismissLoader(()=>cancelAnimationFrame(lRaf));
            }, 3000);
        } else setTimeout(()=>$54b47fc030b7b21e$var$dismissLoader(), 3000);
    }
}


//# sourceMappingURL=playground.595e8c1d.js.map
